// Centralized handling for non-answer survey responses.
//
// When a representative response carries no real content (e.g. "N/A", "none",
// a lone dash, or blank), we display "No additional comments" instead of the
// raw token. Keep the NON_RESPONSES set here so it stays in one place and
// mirrors the backend NON_RESPONSES list.

export const NO_ADDITIONAL_COMMENTS = "No additional comments";

// Compared against the trimmed, lower-cased response text.
export const NON_RESPONSES = new Set([
  "n/a",
  "na",
  "n/c",
  "nc",
  "none",
  "nil",
  "nothing",
  "no idea",
  "no clue",
  "no clue.",
  "not sure",
  "unsure",
  "tbd",
  "unknown",
  "unclear",
  "-",
  "--",
  "—",
]);

// True when the value is empty/whitespace-only or a known non-answer token.
export const isNonResponse = (text) => {
  if (text === null || text === undefined) return true;
  const normalized = String(text).trim().toLowerCase();
  if (normalized === "") return true;
  return NON_RESPONSES.has(normalized);
};

// Returns "No additional comments" for non-answers, otherwise the original text.
export const formatResponseText = (text) => {
  if (isNonResponse(text)) return NO_ADDITIONAL_COMMENTS;
  return text;
};
